import { Grid } from '@mui/material';
import { useState } from 'react';
import BlockSettings, { BlockAlign, BlockJustify } from '../../models/BlockSettings';
import Utils from '../../utils/Utils';
import BlockSettingsModal from '../Modals/BlockSettingsModal/BlockSettingsModal';

interface GridWithSettingsProps {
  children: React.ReactNode;
  settings: BlockSettings;
  isEditing: boolean;
  direction?: 'row' | 'column';
  hideAlign?: boolean;
  hideJustify?: boolean;
  updateHandler: (item: any) => void;
}

const GridWithSettings = ({
  children, settings, isEditing, direction = 'column', hideAlign = false, hideJustify = false, updateHandler,
}: GridWithSettingsProps) => {
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [gridSettings, setGridSettings] = useState(settings);

  const handleOpenSettingsModal = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isEditing) return;
    setOpenSettingsModal(true);
    event.stopPropagation();
  };

  const handleCloseSettingsModal = () => {
    setGridSettings(settings);
    setOpenSettingsModal(false);
  };

  const handleSaveSettingsModal = () => {
    updateHandler(gridSettings);
    setOpenSettingsModal(false);
  };
  const handleChangeAlign = (target: BlockAlign) => {
    setGridSettings({ ...gridSettings, align: target });
  };
  const handleChangeJustify = (target: BlockJustify) => setGridSettings({ ...gridSettings, justify: target });

  return (
    <>
      <Grid
        container
        onClick={handleOpenSettingsModal}
        spacing={0}
        direction={direction}
        minWidth={300}
        alignItems={settings.align}
        justifyContent={settings.justify}
        sx={[Utils.hoverBorder(isEditing), {
          overflow: 'hidden',
          padding: 2,
        }]}
      >

        {children}

      </Grid>
      <BlockSettingsModal
        openModal={openSettingsModal}
        onCloseModal={handleCloseSettingsModal}
        onSaveModal={handleSaveSettingsModal}
        onChangeAlign={handleChangeAlign}
        onChangeJustify={handleChangeJustify}
        settings={gridSettings}
        direction={direction}
        hideAlign={hideAlign}
        hideJustify={hideJustify}
      />
    </>
  );
};

export default GridWithSettings;
